// 原型 .bu-publicdata-tour / entryGuides：xBIOS 落地页触发、挖空主导航项的入口指引。
export const PUBLIC_DATA_GUIDE_EVENT = 'gutdb-public-data-guide'
export const SKIP_KEY = 'biointelos-skip-public-data-navigation-v1'
export const COMMUNITY_SKIP_KEY = 'biointelos-skip-community-navigation-v1'

export const ENTRY_GUIDES = {
  'public-data': {
    navPath: '/dataset',
    skipKey: SKIP_KEY,
    route: { path: '/dataset', query: { tab: 'query' } },
    focusAfter: '.filter-search-input',
    title: '在数聚空间寻找公共数据',
    description: '进入「数聚查询」，可以使用 AI 检索模式。直接描述疾病、样本或研究目标，用对话快速找到合适的公共数据。',
    action: '进入数聚查询',
    showAiPath: true,
  },
  community: {
    navPath: '/community',
    skipKey: COMMUNITY_SKIP_KEY,
    route: { path: '/community' },
    title: '在成果社区，找到提问的灵感',
    description: '看看别人研究了什么、如何向 AI 描述问题，以及最后做出了什么。从具体案例中，找到表达自己想法的思路。',
    action: '进入成果社区',
    showAiPath: false,
  },
}
